<template>
  <picture
    class="picture"
    @click="$emit('click')"
  >
    <source
      :srcset="getSrcSet(lazyLoadImage)"
      :media="lazyLoadImage.mediaQuery"
    />
    <img
      class="picture__img"
      :src="defaultAvatar"
      :alt="alt"
      height="40"
      width="40"
    />
  </picture>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import type { TImageSize } from '~/types/common';
  import defaultAvatar from '~/assets/images/raster/default-comment-avatar.jpg';

  interface IImage {
    imageSizes: TImageSize[];
    mediaQuery: string;
  }
  export default defineNuxtComponent({
    name: 'PictureContact',

    props: {
      alt: {
        type: String as PropType<string>,
        default: 'Изображение',
      },

      sizes: {
        type: Array as PropType<TImageSize[] | null>,
        default: null,
      },
    },

    emits: ['click'],

    computed: {
      defaultAvatar: () => defaultAvatar,

      image(): IImage | undefined {
        const slice: TImageSize | undefined = this.sizes?.[0];
        const imageSizes: TImageSize[] | undefined = [];
        if (slice) {
          imageSizes.push(slice);
          this.sizes?.forEach((item: TImageSize) => {
            if (slice.width * 2 === item.width) {
              imageSizes.push(item);
            }
          });

          return {
            imageSizes,
            mediaQuery: '(min-width: 0px)',
          };
        }
        return undefined;
      },

      srcsetForNoScript(): string | undefined {
        const images = this.sizes?.slice(0, 5);

        return images
          ?.map((item) => {
            return `${item.url} ${item.width}w`;
          })
          .join(', ');
      },

      lazyLoadImage(): any | null {
        return this.image || null;
      },
    },

    methods: {
      getSrcSet(image: any) {
        const images = image.imageSizes;
        if (images.length > 1) {
          return `${images[0].url} 1x, ${images[1].url} 2x`;
        }
        return images[0].url;
      },
    },
  });
</script>

<style lang="scss" scoped>
  .picture {
    display: block;
    width: 100%;
    position: relative;
    &__img {
      display: block;
      width: 100%;
      max-width: 100%;
      height: auto;
      &--noscript {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        width: 100%;
        height: 100%;
      }
    }
  }
</style>
